import React, { useEffect, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import HeaderDashboard from '../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import { SystemButton, SystemTextEditor } from '../library';
import HttpRequest from '../service/httpService'
import { toast } from 'react-toastify';
import { SystemDashboardLayout, SystemPanel } from 'library';
import { getUserId, getUserInfo, getSettingValue } from '../service/userService';
import { Button } from '../library/common/BaseControls';
import { TextArea } from '@progress/kendo-react-inputs';
import { useForm } from "react-hook-form";
import SystemDatePicker from '../library/inputs/SystemDatePicker';
import SystemInputBox from '../library/inputs/SystemInputBox';


const PaystubConfiguration = () => {

    const [userName, setUserName] = useState('');
    const [configValue, setConfigValue] = useState('');
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, getValues, clearErrors } = useForm({});

    const submitForm = async (data, event) => {
        if (!data.userName || !startDate || !endDate) {
            toast.error("Please provide user and date information.");
            return;
        }
        data.startDate = startDate;
        data.endDate = endDate;

        HttpRequest.post("Report/PaystubConfiguration", data).then((response) => {
            if (response && response.data === 1) {
                event.target.reset();
                setStartDate(null);
                setEndDate(null);
                toast.info("Request Submitted Successfully.")
            }
        });
    }
    useEffect(() => {
        let config = getSettingValue("FormerEmployeePayStubRetentionPeriod")
        setConfigValue(config);
    }, [])

    return (
        <>
            <div className="DashboardWrapperChild contact-request">
                <div className="contentWrapper">
                    <HeaderDashboard title="Paystub Configuration" tagLine="" />
                    <div className="container-fluid mt-80 fieldsetGridAndForm">
                        <SystemPanel label="Contact Request" showAdd={false} showRefresh={false} showArchive={false}>
                            <form className="row NewFormReDesign form-group" onSubmit={handleSubmit(submitForm)}>

                                <div className=" col-md-12">
                                    <div className="col-md-12">
                                        <div className="form-group row col-md-12">
                                            <div className="col-md-12">
                                                <label className="mb-5 mt-5">By default, system displays last {configValue} days Paystub Detail.<br />
                                                    You can add additional pay period (Which will expire in 7 day(s)) to Paystub Details here for any employee.</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="col-md-12">
                                            <div className="form-group row">
                                                <div className="col-md-4">
                                                    <label >User Name:</label>
                                                </div>
                                                <div className="col-md-8" >
                                                    <input type="text" {...register("userName")} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <SystemDatePicker
                                                labelClass="col-md-4"
                                                componentClass="col-md-8"
                                                value={startDate}
                                                label="Pay Period Start date"
                                                onkeydown="return false;" onChange={(e) => {
                                                    if (e) {
                                                        setStartDate(e.target.value);
                                                    }
                                                }} />
                                        </div>
                                        <div className="col-md-12">
                                            <SystemDatePicker
                                                labelClass="col-md-4"
                                                componentClass="col-md-8"
                                                value={endDate}
                                                label="Pay Period End Date"
                                                onChange={(e) => {
                                                    if (e) {
                                                        setEndDate(e.target.value);
                                                    }
                                                }} />
                                        </div>
                                        <button type="submit" style={{ width: "150px" }} className="mt-5 btn btnSave">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </SystemPanel>
                    </div>
                </div>
            </div>
        </>
    )
};
export default PaystubConfiguration;
